export default "__VITE_ASSET__DKpNwt85__"